import circleBg from '@/assets/notifications/withdrawal-failed/medallion-x-circle.svg';
import xMark from '@/assets/notifications/withdrawal-failed/medallion-x-mark.svg';
import { POPUP_CTA } from '@/lib/notifications/popup-cta';
import { Medallion } from '../Medallion';
import { PopupCta, PopupLinkCta } from '../PopupCta';
import type { PopupViewProps } from '../types';

const CTA = POPUP_CTA['withdrawal-failed'];

/**
 * WITHDRAW_FAILED — reassuring (NOT alarming) failure. Layout order differs from
 * every other pop-up: TITLE → medallion → body → CTA. Tone is a purple X (not
 * red) and the copy promises the funds are safe (the producer refunds the wallet
 * atomically with the FAILED/REJECTED flip). Dual CTA: "Back to lobby" primary +
 * a "Contact Support" text link (forced LTR — the Figma node was authored rtl).
 * Copy is static — no meta is read.
 */
export function WithdrawFailedPopup({ onAction }: PopupViewProps) {
  const secondary = CTA.secondary;
  return (
    <>
      <h2 className="text-2xl font-semibold tracking-[-0.48px] text-ink">Withdraw didn’t go through</h2>

      <Medallion circleSrc={circleBg} illustrationSrc={xMark} tone="neutral" size={140} illustrationSize={70} alt="" />

      <div className="flex flex-col items-center gap-1 text-xl text-ink">
        <p>Don’t worry.</p>
        <p>Your money is still in your balance.</p>
      </div>

      <div className="flex flex-col items-center gap-3">
        <PopupCta
          label={CTA.primary.label}
          width={270}
          onClick={() => onAction(CTA.primary.action)}
          testId="popup-cta-primary"
        />
        {secondary && (
          <PopupLinkCta label={secondary.label} onClick={() => onAction(secondary.action)} testId="popup-cta-secondary" />
        )}
      </div>
    </>
  );
}
